import { render, staticRenderFns } from "./QuemSomosView.vue?vue&type=template&id=282f9e90&"
import script from "./quemsomos.js?vue&type=script&lang=js&"
export * from "./quemsomos.js?vue&type=script&lang=js&"
import style0 from "./QuemSomosView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports